import { apiClient } from "./client";
import type {
  ProposalTemplate,
  ProposalTemplateResolved,
  ProposalTemplatesPaginated,
  ProposalTemplateCreate,
  ProposalTemplateUpdate,
  MessageResponse,
} from "@/types";

// ============== Templates CRUD ==============

// Create a new template for a version
export async function createProposalTemplate(
  versionId: number,
  data: ProposalTemplateCreate
): Promise<ProposalTemplate> {
  const response = await apiClient.post<ProposalTemplate>(
    `/versions/${versionId}/proposal-templates`,
    data
  );
  return response.data;
}

// List templates for a version
interface ListTemplatesParams {
  page?: number;
  page_size?: number;
  active_only?: boolean;
  parents_only?: boolean; // If true, only return templates that can be parents (no parent themselves)
}

export async function listProposalTemplates(
  versionId: number,
  params: ListTemplatesParams = {}
): Promise<ProposalTemplatesPaginated> {
  const response = await apiClient.get<ProposalTemplatesPaginated>(
    `/versions/${versionId}/proposal-templates`,
    { params }
  );
  return response.data;
}

// Get template with resolved pages (parent pages + own pages)
export async function getProposalTemplate(
  templateId: number
): Promise<ProposalTemplateResolved> {
  const response = await apiClient.get<ProposalTemplateResolved>(
    `/proposal-templates/${templateId}`
  );
  return response.data;
}

// Update template
export async function updateProposalTemplate(
  templateId: number,
  data: ProposalTemplateUpdate
): Promise<ProposalTemplate> {
  const response = await apiClient.put<ProposalTemplate>(
    `/proposal-templates/${templateId}`,
    data
  );
  return response.data;
}

// Delete template
export async function deleteProposalTemplate(
  templateId: number
): Promise<MessageResponse> {
  const response = await apiClient.delete<MessageResponse>(
    `/proposal-templates/${templateId}`
  );
  return response.data;
}

// Duplicate template
export async function duplicateProposalTemplate(
  templateId: number
): Promise<ProposalTemplate> {
  const response = await apiClient.post<ProposalTemplate>(
    `/proposal-templates/${templateId}/duplicate`
  );
  return response.data;
}
